// Payments statuses
export const STATUS_FAILED = 'FAILED';
const AUTHORIZATION_FAILED = 'AUTHORIZATION_FAILED';
const STATUS_ACCEPTED_BY_BANK = 'ACCEPTED_BY_BANK';
const STATUS_REQUIRES_MANUAL_REVIEW = 'REQUIRES_MANUAL_REVIEW';
const STATUS_PENDING_WITH_BANK = 'PENDING_WITH_BANK';
const STATUS_AWAITING_AUTHORIZATION = 'AWAITING_AUTHORIZATION';
const STATUS_AWAITING_PAYMENT_MFA_TOKEN = 'AWAITING_PAYMENT_MFA_TOKEN';
const STATUS_MFA_ATTEMPTS_EXHAUSTED = 'MFA_ATTEMPTS_EXHAUSTED';
const STATUS_INVALID_PAYMENT_MFA = 'INVALID_PAYMENT_MFA';
const STATUS_AWAITING_AUTHORIZATION_PAYMENT_MFA =
  'AWAITING_AUTHORIZATION_PAYMENT_MFA';
const STATUS_INVALID_AUTHORIZATION_PAYMENT_MFA =
  'INVALID_AUTHORIZATION_PAYMENT_MFA';
const STATUS_AUTHORIZATION_MFA_ATTEMPTS_EXHAUSTED =
  'AUTHORIZATION_MFA_ATTEMPTS_EXHAUSTED';
const STATUS_CANCELLED = 'CANCELLED';
const STATUS_AWAITING_BENEFICIARY_COOL_OFF = 'AWAITING_BENEFICIARY_COOL_OFF';

const FAILED = 'Failed';
const ACCEPTED = 'Accepted';
const PENDING = 'Pending';
const UNRESOLVED = 'Unresolved';
const AWAITING_AUTHORIZATION = 'Awaiting authorization';
const CANCELLED = 'Cancelled';
const AWAITING_MFA = 'Awaiting MFA';
const INVALID_MFA = 'Invalid MFA';
const AWAITING_AUTHORIZATION_MFA = 'Awaiting authorization MFA';
const INVALID_AUTHORIZATION_MFA = 'Invalid authorization MFA';
const MFA_ATTEMPTS_EXHAUSTED = 'MFA attempts exhausted';
const AWAITING_BENEFICIARY_COOL_OFF = 'Awaiting beneficiary cool off';

// Refunds statuses
export const STATUS_CREATED = 'CREATED';
export const STATUS_REJECTED = 'REJECTED';
export const STATUS_APPROVED = 'APPROVED';
export const STATUS_PROCESSED = 'PROCESSED';

const CREATED = 'Created';
const REJECTED = 'Rejected';
const APPROVED = 'Approved';
const PROCESSED = 'Processed';

export const PAYMENTS_REFUNDS = 'payments-refunds';
export const PAYMENTS_PAYOUTS = 'payments-payouts';
export const PAYMENTS_RECEIVED = 'payments-received';

interface StatusLabel {
  [key: string]: {
    title: string;
    type: string;
  };
}

interface LabelValue {
  label: string;
  value: string;
}

export const PAYMENTS_STATUS_TO_LABEL: StatusLabel = {
  [STATUS_ACCEPTED_BY_BANK]: {
    title: ACCEPTED,
    type: 'success',
  },
  [STATUS_FAILED]: {
    title: FAILED,
    type: 'danger',
  },
  [AUTHORIZATION_FAILED]: {
    title: FAILED,
    type: 'danger',
  },
  [STATUS_REQUIRES_MANUAL_REVIEW]: {
    title: UNRESOLVED,
    type: 'secondary',
  },
  [STATUS_PENDING_WITH_BANK]: {
    title: PENDING,
    type: 'primary',
  },
  [STATUS_AWAITING_AUTHORIZATION]: {
    title: AWAITING_AUTHORIZATION,
    type: 'primary',
  },
  [STATUS_CANCELLED]: {
    title: CANCELLED,
    type: 'secondary',
  },
  [STATUS_AWAITING_PAYMENT_MFA_TOKEN]: {
    title: AWAITING_MFA,
    type: 'primary',
  },
  [STATUS_MFA_ATTEMPTS_EXHAUSTED]: {
    title: MFA_ATTEMPTS_EXHAUSTED,
    type: 'danger',
  },
  [STATUS_INVALID_PAYMENT_MFA]: {
    title: INVALID_MFA,
    type: 'danger',
  },
  [STATUS_AWAITING_AUTHORIZATION_PAYMENT_MFA]: {
    title: AWAITING_AUTHORIZATION_MFA,
    type: 'primary',
  },
  [STATUS_INVALID_AUTHORIZATION_PAYMENT_MFA]: {
    title: INVALID_AUTHORIZATION_MFA,
    type: 'danger',
  },
  [STATUS_AUTHORIZATION_MFA_ATTEMPTS_EXHAUSTED]: {
    title: MFA_ATTEMPTS_EXHAUSTED,
    type: 'danger',
  },
  [STATUS_AWAITING_BENEFICIARY_COOL_OFF]: {
    title: AWAITING_BENEFICIARY_COOL_OFF,
    type: 'primary',
  },
  [STATUS_CREATED]: {
    title: CREATED,
    type: 'primary',
  },
  [STATUS_REJECTED]: {
    title: REJECTED,
    type: 'danger',
  },
  [STATUS_APPROVED]: {
    title: APPROVED,
    type: 'primary',
  },
  [STATUS_PROCESSED]: {
    title: PROCESSED,
    type: 'success',
  }
};

export const DEFAULT_STATUS_LABEL = {
  title: UNRESOLVED,
  type: 'secondary',
};

export const STATUS_FILTER_OPTIONS: LabelValue[] = [
  { label: FAILED, value: STATUS_FAILED },
  { label: ACCEPTED, value: STATUS_ACCEPTED_BY_BANK },
  { label: PENDING, value: STATUS_PENDING_WITH_BANK },
  { label: UNRESOLVED, value: STATUS_REQUIRES_MANUAL_REVIEW },
  { label: AWAITING_AUTHORIZATION, value: STATUS_AWAITING_AUTHORIZATION },
];

export const REFUND_STATUS_FILTER_OPTIONS: LabelValue[] = [
  { label: CREATED, value: STATUS_CREATED },
  { label: REJECTED, value: STATUS_REJECTED },
  { label: APPROVED, value: STATUS_APPROVED },
  { label: PROCESSED, value: STATUS_PROCESSED },
  ...STATUS_FILTER_OPTIONS,
];
